import * as mobx from "mobx";
import { configure } from "mobx";
import { PubSub } from "@al/aku-lc-pubsub";
import { container, ENV_KEY, PUB_SUB, Container } from "./container";
configure({
    useProxies: "ifavailable",
});
container.inject(PUB_SUB, new PubSub());
export { mobx, container, ENV_KEY, Container };
// export function createApp(options: IAppProps): IApp {
//   return new App(options);
// }
export { App } from "./models/app";
export { Aggregator } from "./models/aggregator";
export { Query } from "./models/query";
export { Form } from "./models/form";
export * from "./models/action";
export * from "./env";
export * from "./helpers/query";
export * from "./types";
